<template>
  <div class="login-container">
    <h2>Autentificare Admin</h2>

    <div class="password-wrapper">
      <input
        :type="showPassword ? 'text' : 'password'"
        v-model="password"
        placeholder="Introdu parola"
        @keyup.enter="login"
      />
      <button type="button" class="toggle-btn" @click="togglePassword">
        <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
      </button>
    </div>

    <button class="login-btn" @click="login">Login</button>
    <p v-if="error" class="error">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      password: "",
      error: "",
      showPassword: false,
      loading: false,
    };
  },
  methods: {
    async login() {
      this.error = "";
      this.loading = true;

      try {
        const response = await fetch("/api/login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ password: this.password }),
        });

        // dacă backend-ul întoarce 401 sau alt status
        if (!response.ok) {
          let msg = `Eroare (${response.status})`;
          try {
            const errData = await response.json();
            msg = errData?.message || msg;
          } catch (_) {}
          this.error = msg;
          return;
        }

        const data = await response.json();

        if (data.success) {
          localStorage.setItem("isLoggedIn", "true");
          localStorage.setItem("adminToken", this.password);
          this.$router.push("/admin");
        } else {
          this.error = data.message || "Parolă incorectă!";
        }
      } catch (err) {
        this.error = "Eroare de conexiune cu serverul!";
      } finally {
        this.loading = false;
      }
    },

    togglePassword() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
}

.password-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.password-wrapper input {
  margin: 1rem 0;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid #aaa;
  width: 240px;
  font-size: 1rem;
}

.toggle-btn {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #f7c600;
  font-size: 1.1rem;
}

.toggle-btn:hover {
  color: #fff;
}

.login-btn {
  background: #222;
  color: white;
  border: none;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
}

.login-btn:hover {
  background: #444;
}

.error {
  color: red;
  margin-top: 0.5rem;
}
</style>

<!-- Font Awesome pentru icon-ul 👁️ -->
<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
/>
